import axios from "axios";
import { env } from "../config/env";

export class ApiError extends Error {
  constructor(status, message, payload) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.payload = payload;
  }
}

export const apiClient = axios.create({
  baseURL: env.apiBaseUrl,
  headers: {
    "x-admin-key": env.adminApiKey,
    "Content-Type": "application/json",
  },
  timeout: 20000,
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status ?? 0;
    const body = error.response?.data;
    const message =
      body?.message || body?.error || error.message || "Request failed";
    return Promise.reject(new ApiError(status, message, body));
  },
);

export async function getJson(url, params) {
  const response = await apiClient.get(url, { params });
  return unwrap(response);
}

export async function putJson(url, body) {
  const response = await apiClient.put(url, body);
  return unwrap(response);
}

export async function patchJson(url, body) {
  const response = await apiClient.patch(url, body);
  return unwrap(response);
}

function unwrap(response) {
  const envelope = response.data;
  if (!envelope?.success) {
    throw new ApiError(
      envelope?.statusCode ?? response.status,
      envelope?.message ?? "Request failed",
      envelope,
    );
  }
  return envelope.data;
}
